/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Action } from './Action';
import {
    ActionFromJSON,
    ActionFromJSONTyped,
    ActionToJSON,
} from './Action';

/**
 * 
 * @export
 * @interface Interaction
 */
export interface Interaction {
    /**
     * 
     * @type {string}
     * @memberof Interaction
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Interaction
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof Interaction
     */
    sessionId: string;
    /**
     * 
     * @type {Array<Action>}
     * @memberof Interaction
     */
    actions: Array<Action>;
}

/**
 * Check if a given object implements the Interaction interface.
 */
export function instanceOfInteraction(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "sessionId" in value;
    isInstance = isInstance && "actions" in value;

    return isInstance;
}

export function InteractionFromJSON(json: any): Interaction {
    return InteractionFromJSONTyped(json, false);
}

export function InteractionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Interaction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': json['userId'],
        'sessionId': json['sessionId'],
        'actions': ((json['actions'] as Array<any>).map(ActionFromJSON)),
    };
}

export function InteractionToJSON(value?: Interaction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'userId': value.userId,
        'sessionId': value.sessionId,
        'actions': ((value.actions as Array<any>).map(ActionToJSON)),
    };
}

